<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Данные об ущербе</h3>
      <div class="step__group" role="group" aria-labelledby="cs1-group-label1">
        <div class="step__minititle" id="cs1-group-label1">Повреждено:</div>
        <div class="step__group-cont">
          <CheckBox name="damagedata-damaged-inner_flat" v-model="form.damagedata.damaged.inner_flat">Внутренняя отделка
            квартиры</CheckBox>
          <CheckBox name="damagedata-damaged-engineer_flat" v-model="form.damagedata.damaged.engineer_flat">Инженерное
            оборудование квартиры</CheckBox>
          <CheckBox name="damagedata-damaged-moving_flat" v-model="form.damagedata.damaged.moving_flat">Движимое
            имущество квартиры</CheckBox>
          <CheckBox name="damagedata-damaged-construction_flat" v-model="form.damagedata.damaged.construction_flat">
            Конструктивные элементы квартиры</CheckBox>
          <CheckBox name="damagedata-damaged-civilian_resp" v-model="form.damagedata.damaged.civilian_resp">Гражданская
            ответственность при эксплуатации квартиры</CheckBox>
          <CheckBox name="damagedata-damaged-inner_house" v-model="form.damagedata.damaged.inner_house">Внутренняя
            отделка дома</CheckBox>
          <CheckBox name="damagedata-damaged-engineer_house" v-model="form.damagedata.damaged.engineer_house">Инженерное
            оборудование дома</CheckBox>
          <CheckBox name="damagedata-damaged-moving_house" v-model="form.damagedata.damaged.moving_house">
            Движимое имущество дома</CheckBox>
          <CheckBox name="damagedata-damaged-construction_house" v-model="form.damagedata.damaged.construction_house">Конструктивные
            элементы дома</CheckBox>
          <CheckBox name="damagedata-damaged-additional_buildings"
            v-model="form.damagedata.damaged.additional_buildings">Дополнительные постройки</CheckBox>
        </div>
      </div>
      <NumberInput :required="true" @setError="errors.estimated_sum = $event" v-model="form.damagedata.estimated_sum"
        text="Предполагаемый размер ущерба в рублях" name="damagedata-estimated_sum" />
      <RadioGroup :required="true" title="О событии заявлено в управляющую компанию/ДЭЗ?" :values="['Да', 'Нет']"
        name="damagedata-DEZ_notified" v-model="form.damagedata.DEZ_notified" />
      <ShortFields v-if="dynamicfields.DEZ_notified">
        <TextInput :required="true" @setError="errors.DEZ_name = $event" v-model="form.damagedata.DEZ.name"
          text="Наименование службы" name="damagedata-DEZ_name" />
        <DateInput :required="true" @setError="errors.DEZ_date = $event" name="damagedata-DEZ_date"
          text="Дата обращения" :range="false" v-model="form.damagedata.DEZ.date" />
      </ShortFields>
      <NumberInput :required="true" mask="#" @setError="errors.roomcount = $event"
        :validation="(v) => (parseInt(v) >= 1 && parseInt(v) <= 5) ? '' : 'Введите число от 1 до 5'"
        v-model="form.damagedata.roomcount" text="Количество пострадавших комнат (1-5)" name="damagedata-roomcount" />
      <Btn class="step__next" :disabled="!filled" @click.stop.prevent="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Btn from '@/components/Btn.vue';
import CheckBox from '@/components/inputs/CheckBox.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import DateInput from '@/components/inputs/DateInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import ShortFields from '@/components/ShortFields.vue';
export default {
  components: { Btn, CheckBox, NumberInput, RadioGroup, ShortFields, TextInput, DateInput },
  data: () => ({
    errors: {},
  }),
  props: {
    active: { type: Boolean }
  },
  computed: {
    ...mapState(['form']),
    dynamicfields() {
      let obj = {}
      if (this.form.damagedata.DEZ_notified == 'Да')
        obj.DEZ_notified = true
      return obj
    },
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false

      const required = ['roomcount', "estimated_sum", "DEZ_notified"]
      for (let key of required)
        if (!this.form.damagedata[key])
          return false

      if (this.dynamicfields.DEZ_notified) {
        let required = ['name', 'date']
        for (let key of required)
          if (!this.form.damagedata.DEZ[key])
            return false
      }

      for (let key in this.form.damagedata.damaged)
        if (this.form.damagedata.damaged[key])
          return true
      return false
    },
  },
}
</script>

<style lang="sass">

</style>